import axios from "axios";
import { NIGHT_EYE_API_URL } from "../Process";
import { useInfiniteQuery, useQuery, useMutation } from "@tanstack/react-query";
import axiosInstance from "./AxiosInstance";
import moment from "moment";
import Cookies from "js-cookie"



export const useTrackingDetailsPagination = (rowsPerPage, filterData) =>
    useInfiniteQuery({
        queryKey: ['trackingDetailsMain', rowsPerPage, filterData], // depends on rowsPerPage
        queryFn: async ({ pageParam = null, }) => {

            const { shopDetailID, startDate, endDate } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""

            let temptItems = {

                "ShopDetailID": shopDetailID || "",
                "StartDate": formateStartData || "",
                "EndDate": formateEndData || "",
                "IsActive": "true",
                "IsDelete": "false",
                "PerPage": rowsPerPage,
                "UniqueID": pageParam
            }
            // if(!userRole){
            //   return 
            // }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shopTrackingDetail/getShopTrackingDetail`, temptItems, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return res.data;
        },
        enabled: !!filterData?.shopDetailID,
        initialPageParam: null, // first page: no cursor
        getNextPageParam: (lastPage) => lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.ShopTrackingDetailID : undefined,
    });
export const useTrackingDetailsExcel = () => {
    return useMutation({
        mutationFn: async (filterData) => {
            const { shopDetailID, startDate, endDate } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""
            let temptItems = {
                "ShopDetailID": shopDetailID || "",
                "StartDate": formateStartData || "",
                "EndDate": formateEndData || "",
                "IsActive": "true",
                "IsDelete": "false",
                "PerPage": "",
                "UniqueID": ""
            }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shopTrackingDetail/getShopTrackingDetail`, temptItems);
            return res?.data?.data
        },
    });
};
export const useActionHistoryDetailsExcel = () => {
    return useMutation({
        mutationFn: async (filterData) => {
            const { shopDetailID, startDate, endDate } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""
            let temptItems = {
                "ShopDetailID": shopDetailID || "",
                "StartDate": formateStartData || "",
                "EndDate": formateEndData || "",
                "IsActive": "true",
                "IsDelete": "false",
                "PerPage": "",
                "UniqueID": ""
            }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shopReportDetail/getShopReportDetail`, temptItems);
            return res?.data?.data
        },
    });
};
export const useShopReportDetailsPagination = (rowsPerPage, filterData) =>
    useInfiniteQuery({
        queryKey: ['shopReportDetailsMain', rowsPerPage, filterData], // depends on rowsPerPage
        queryFn: async ({ pageParam = null, }) => {

            const { shopDetailID, startDate, endDate } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""

            let temptItems = {

                "ShopDetailID": shopDetailID || "",
                "StartDate": formateStartData || "",
                "EndDate": formateEndData || "",
                "IsActive": "true",
                "IsDelete": "false",
                "PerPage": rowsPerPage,
                "UniqueID": pageParam
            }
            // if(!userRole){
            //   return 
            // }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shopReportDetail/getShopReportDetail`, temptItems, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return res.data;
        },
        enabled: !!filterData?.shopDetailID,
        initialPageParam: null, // first page: no cursor
        getNextPageParam: (lastPage) => lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.ShopReportDetailID : undefined,
    });
    export const useUserDetailsPagination = (rowsPerPage, filterData) =>
        useInfiniteQuery({
            queryKey: ['userDetailsMainPagination', rowsPerPage, filterData], // depends on rowsPerPage
            queryFn: async ({ pageParam = null, }) => {
    
                const { startDate, endDate, zoneID, policeStationID, userName, areaID, cityID, createdByUserID } = filterData || {}
                let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
                let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""
    
                let temptItems = {
                    "CityID": cityID || "",
                    "ZoneID": zoneID || "",
                    "PoliceStationID": policeStationID || "",
                    "AreaID": areaID || "",
                    "UserName": userName || "",
                    "StartDate": formateStartData || "",
                    "EndDate": formateEndData || "",
                    "CreatedByUserID": createdByUserID || "",
                    "IsActive": "",
                    "IsDelete": "false",
                    "PerPage": rowsPerPage,
                    "UniqueID": pageParam
                }
                // if(!userRole){
                //   return 
                // }
    
                const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}user/getUser`, temptItems, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
                return res.data;
            },
            initialPageParam: null, // first page: no cursor
            getNextPageParam: (lastPage) => lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.UserID : undefined,
        });
export const useShopDetailsPagination = (rowsPerPage, filterData) =>
    useInfiniteQuery({
        queryKey: ['shopDetailsMain', rowsPerPage, filterData], // depends on rowsPerPage
        queryFn: async ({ pageParam = null, }) => {

            const { shopDetailID, startDate, endDate, zoneID, policeStationID, divisionID, areaID, cityID,
                shopOwnerMobileNo, shopOwnerName, shopName, isCCTVAvailable,
                isStreetLightAvailable,
                isAgreementAvailable,
                isShopOwnorOnRentOrOnSubTenant,
                isRentExpired,
                createdByUserID,
                shopType } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""

            let temptItems = {
                "ShopDetailID": shopDetailID || "",
                "CityID": cityID || "",
                "ZoneID": zoneID || "",
                "PoliceStationID": policeStationID || "",
                "DivisionID": divisionID || "",
                "AreaID": areaID || "",
                "ShopOwnerMobileNo": shopOwnerMobileNo || "",
                "ShopOwnerName": shopOwnerName || "",
                "ShopName": shopName || "",
                "TypeMasterID": shopType || "",
                "IsCCTVAvailable": isCCTVAvailable || "",
                "IsStreetLightAvailable": isStreetLightAvailable || "",
                "IsAgreementAvailable": isAgreementAvailable || "",
                "IsShopOwnorOnRentOrOnSubTenant": isShopOwnorOnRentOrOnSubTenant || "",
                "IsRentExpired": isRentExpired || "",
                "StartDate": formateStartData || "",
                "EndDate": formateEndData || "",
                "CreatedByUserID": createdByUserID || "",
                "IsActive": "",
                "IsDelete": "false",
                "PerPage": rowsPerPage,
                "UniqueID": pageParam
            }
            // if(!userRole){
            //   return 
            // }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shop/getShopDetail`, temptItems, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return res.data;
        },
        initialPageParam: null, // first page: no cursor
        getNextPageParam: (lastPage) => lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.ShopDetailID : undefined,
    });

export const useShopDetailsExcel = () => {
    return useMutation({
        mutationFn: async (filterData) => {
            const { shopDetailID, startDate, endDate, zoneID, policeStationID, divisionID, areaID, cityID, shopOwnerMobileNo,
                shopOwnerName, shopName, isCCTVAvailable,
                isStreetLightAvailable,
                isAgreementAvailable,
                isShopOwnorOnRentOrOnSubTenant,
                isRentExpired,
                shopType,
                createdByUserID } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""
            let temptItems = {
                "ShopDetailID": shopDetailID || "",
                "CityID": cityID || "",
                "ZoneID": zoneID || "",
                "PoliceStationID": policeStationID || "",
                "DivisionID": divisionID || "",
                "AreaID": areaID || "",
                "ShopOwnerMobileNo": shopOwnerMobileNo?.trim() || "",
                "ShopOwnerName": shopOwnerName?.trim() || "",
                "ShopName": shopName?.trim() || "",
                "TypeMasterID": shopType || "",
                "IsCCTVAvailable": isCCTVAvailable || "",
                "IsStreetLightAvailable": isStreetLightAvailable || "",
                "IsAgreementAvailable": isAgreementAvailable || "",
                "IsShopOwnorOnRentOrOnSubTenant": isShopOwnorOnRentOrOnSubTenant || "",
                "IsRentExpired": isRentExpired || "",
                "StartDate": formateStartData || "",
                "EndDate": formateEndData || "",
                "CreatedByUserID": createdByUserID || "",
                "IsActive": "",
                "IsDelete": "false",
                "PerPage": "",
                "UniqueID": ""
            }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shop/getShopDetail`, temptItems);
            return res?.data?.data
        },
    });
};


export const useUserDetailsExcel = () => {
    return useMutation({
        mutationFn: async (filterData) => {
            const { startDate, endDate, zoneID, policeStationID, userName, areaID, cityID, createdByUserID } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""
            let temptItems = {
                "CityID": cityID || "",
                "ZoneID": zoneID || "",
                "PoliceStationID": policeStationID || "",
                "AreaID": areaID || "",
                "UserName": userName || "",
                "StartDate": formateStartData || "",
                "EndDate": formateEndData || "",
                "CreatedByUserID": createdByUserID || "",
                "IsActive": "",
                "IsDelete": "false",
                "PerPage": "",
                "UniqueID": ""
            }
            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}user/getUser`, temptItems);
            return res?.data?.data
        },
    });
};

export const useOpenShopDetailsPagination = (rowsPerPage, filterData) =>
    useInfiniteQuery({
        queryKey: ['openShopDetailsMain', rowsPerPage, filterData], // depends on rowsPerPage
        queryFn: async ({ pageParam = null, }) => {

            const { shopOwnerName, shopOwnerMobileNo, shopDetailID, startDate, endDate, zoneID, policeStationID, divisionID, areaID, cityID } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""

            let temptItems = {
                "ShopDetailID": shopDetailID || "",
                "CityID": cityID || "",
                "ZoneID": zoneID || "",
                "PoliceStationID": policeStationID || "",
                "DivisionID": divisionID || "",
                "AreaID": areaID || "",
                "OwnerName": shopOwnerName || "",
                "OwnerMobileNo": shopOwnerMobileNo || "",
                "StartDate": formateStartData || "",
                "EndDate": formateEndData || "",
                "IsActive": "true",
                "IsDelete": "false",
                "PerPage": rowsPerPage,
                "UniqueID": pageParam
            }
            // if(!userRole){
            //   return 
            // }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shop/getShopOpenDetail`, temptItems, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return res.data;
        },
        initialPageParam: null, // first page: no cursor
        getNextPageParam: (lastPage) => lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.ShopDetailID : undefined,
    });
export const useCloseShopDetailsPagination = (rowsPerPage, filterData) =>
    useInfiniteQuery({
        queryKey: ['closeShopDetailsMain', rowsPerPage, filterData], // depends on rowsPerPage
        queryFn: async ({ pageParam = null, }) => {

            const { shopOwnerName, shopOwnerMobileNo, shopDetailID, startDate, endDate, zoneID, policeStationID, divisionID, areaID, cityID } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""

            let temptItems = {
                "ShopDetailID": shopDetailID || "",
                "CityID": cityID || "",
                "ZoneID": zoneID || "",
                "PoliceStationID": policeStationID || "",
                "DivisionID": divisionID || "",
                "AreaID": areaID || "",
                "OwnerName": shopOwnerName || "",
                "OwnerMobileNo": shopOwnerMobileNo || "",
                "StartDate": formateStartData || "",
                "EndDate": formateEndData || "",
                "IsActive": "true",
                "IsDelete": "false",
                "PerPage": rowsPerPage,
                "UniqueID": pageParam
            }
            // if(!userRole){
            //   return 
            // }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shop/getShopCloseDetail`, temptItems, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return res.data;
        },
        initialPageParam: null, // first page: no cursor
        getNextPageParam: (lastPage) => lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.ShopDetailID : undefined,
    });

export const useOpenShopDetailsExcel = () => {
    return useMutation({
        mutationFn: async (filterData) => {
            const { shopOwnerName, shopOwnerMobileNo, shopDetailID, startDate, endDate, zoneID, policeStationID, divisionID, areaID, cityID } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""
            let temptItems = {
                "ShopDetailID": shopDetailID || "",
                "CityID": cityID || "",
                "ZoneID": zoneID || "",
                "PoliceStationID": policeStationID || "",
                "DivisionID": divisionID || "",
                "AreaID": areaID || "",
                "OwnerName": shopOwnerName || "",
                "OwnerMobileNo": shopOwnerMobileNo || "",
                "StartDate": formateStartData || "",
                "EndDate": formateEndData || "",
                "IsActive": "true",
                "IsDelete": "false",
                "PerPage": "",
                "UniqueID": ""
            }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shop/getShopOpenDetail`, temptItems);
            return res?.data?.data
        },
    });
};
export const useCloseShopDetailsExcel = () => {
    return useMutation({
        mutationFn: async (filterData) => {
            const { shopOwnerName, shopOwnerMobileNo, shopDetailID, startDate, endDate, zoneID, policeStationID, divisionID, areaID, cityID } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""
            let temptItems = {
                "ShopDetailID": shopDetailID || "",
                "CityID": cityID || "",
                "ZoneID": zoneID || "",
                "PoliceStationID": policeStationID || "",
                "DivisionID": divisionID || "",
                "AreaID": areaID || "",
                "OwnerName": shopOwnerName || "",
                "OwnerMobileNo": shopOwnerMobileNo || "",
                "StartDate": formateStartData || "",
                "EndDate": formateEndData || "",
                "IsActive": "true",
                "IsDelete": "false",
                "PerPage": "",
                "UniqueID": ""
            }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shop/getShopCloseDetail`, temptItems);
            return res?.data?.data
        },
    });
};
export const useViolationDetailsExcel = () => {
    return useMutation({
        mutationFn: async (filterData) => {
            const { shopDetailID, startDate, endDate, zoneID, policeStationID, divisionID, areaID, cityID, violationsTypeID, isShopOpenCloseViolation, shopOwnerMobileNo, shopOwnerName, shopName } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""
            let temptItems = {
                "ShopDetailID": shopDetailID || "",
                "CityID": cityID || "",
                "ZoneID": zoneID || "",
                "PoliceStationID": policeStationID || "",
                "DivisionID": divisionID || "",
                "AreaID": areaID || "",
                "ShopOwnerMobileNo": shopOwnerMobileNo || "",
                "ShopOwnerName": shopOwnerName || "",
                "ShopName": shopName || "",
                "IsShopOpenCloseViolation": isShopOpenCloseViolation || "",
                "ViolationsTypeID": violationsTypeID || "",
                "StartDate": formateStartData || "",
                "EndDate": formateEndData || "",
                "IsActive": "true",
                "IsDelete": "false",
                "PerPage": "",
                "UniqueID": ""
            }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shopReportDetail/getShopReportDetail`, temptItems);
            return res?.data?.data
        },
    });
};
export const useShopViolationDetailsPagination = (rowsPerPage, filterData) =>
    useInfiniteQuery({
        queryKey: ['shopReportDetailsMain', rowsPerPage, filterData], // depends on rowsPerPage
        queryFn: async ({ pageParam = null, }) => {

            const { shopDetailID, startDate, endDate, zoneID, policeStationID, divisionID, areaID, cityID, violationsTypeID, isShopOpenCloseViolation, shopOwnerMobileNo, shopOwnerName, shopName } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""

            let temptItems = {

                "ShopDetailID": shopDetailID || "",
                "CityID": cityID || "",
                "ZoneID": zoneID || "",
                "PoliceStationID": policeStationID || "",
                "DivisionID": divisionID || "",
                "AreaID": areaID || "",
                "IsShopOpenCloseViolation": isShopOpenCloseViolation || "",
                "ViolationsTypeID": violationsTypeID || "",
                "ShopOwnerMobileNo": shopOwnerMobileNo || "",
                "ShopOwnerName": shopOwnerName || "",
                "ShopName": shopName || "",
                "StartDate": formateStartData || "",
                "EndDate": formateEndData || "",
                "IsActive": "true",
                "IsDelete": "false",
                "PerPage": rowsPerPage,
                "UniqueID": pageParam
            }
            // if(!userRole){
            //   return 
            // }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shopReportDetail/getShopReportDetail`, temptItems, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return res.data;
        },

        initialPageParam: null, // first page: no cursor
        getNextPageParam: (lastPage) => lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.ShopReportDetailID : undefined,
    });
export const useShopCloseDetailsExcel = () => {
    return useMutation({
        mutationFn: async (filterData) => {
            const { shopDetailID, startDate, endDate, zoneID, policeStationID, divisionID, areaID, cityID, shopOwnerMobileNo, shopOwnerName, shopName } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""
            let temptItems = {
                "ShopDetailID": shopDetailID || "",
                "CityID": cityID || "",
                "ZoneID": zoneID || "",
                "PoliceStationID": policeStationID || "",
                "DivisionID": divisionID || "",
                "AreaID": areaID || "",
                "ShopOwnerMobileNo": shopOwnerMobileNo || "",
                "ShopOwnerName": shopOwnerName || "",
                "ShopName": shopName || "",
                "StartDate": formateStartData || "",
                "EndDate": formateEndData || "",
                "IsActive": "true",
                "IsDelete": "false",
                "PerPage": "",
                "UniqueID": ""
            }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shopTrackingDetail/getShopLateClosureDetailData`, temptItems);
            return res?.data?.data
        },
    });
};
export const useShopCloseDetailsPagination = (rowsPerPage, filterData) =>
    useInfiniteQuery({
        queryKey: ['shopReportDetailsMain', rowsPerPage, filterData], // depends on rowsPerPage
        queryFn: async ({ pageParam = null, }) => {

            const { shopDetailID, startDate, endDate, zoneID, policeStationID, divisionID, areaID, cityID, shopOwnerMobileNo, shopOwnerName, shopName } = filterData || {}
            // let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            // let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""
            const startDateTime = startDate
                ? moment(startDate).format('DD-MM-YYYY HH:mm:ss')
                : "";

            const endDateTime = endDate
                ? moment(endDate).format('DD-MM-YYYY HH:mm:ss')
                : "";
            let temptItems = {

                "ShopDetailID": shopDetailID || "",
                "CityID": cityID || "",
                "ZoneID": zoneID || "",
                "PoliceStationID": policeStationID || "",
                "DivisionID": divisionID || "",
                "AreaID": areaID || "",
                "ShopOwnerMobileNo": shopOwnerMobileNo || "",
                "ShopOwnerName": shopOwnerName || "",
                "ShopName": shopName || "",
                "StartDate": startDateTime || "",
                "EndDate": endDateTime || "",
                "IsActive": "true",
                "IsDelete": "false",
                "PerPage": rowsPerPage,
                "UniqueID": pageParam
            }
            // if(!userRole){
            //   return 
            // }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shopTrackingDetail/getShopLateClosureDetailData`, temptItems, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return res.data;
        },

        initialPageParam: null, // first page: no cursor
        getNextPageParam: (lastPage) => lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.ShopTrackingDetailID : undefined,
    });

export const useShopOwnRentorSubtenantCount = (countFilterData) =>
    useQuery({
        queryKey: ["use-shop-own-rentorSubtenantCount", { countFilterData }],
        queryFn: fetchShopOwnRentorSubtenantCount,
        // staleTime: 5 * 60 * 1000,
        retry: 1,
    });

export const useTypeMasterData = (category) =>
    useQuery({
        queryKey: ["use-type-master-data", { category }],
        queryFn: fetchTypeMaster,
        // staleTime: 5 * 60 * 1000,
        retry: 1,
    });

export const useAreaData = (cityID, zoneID, policeStationID, areaID) =>
    useQuery({
        queryKey: ["use-area-data", { cityID, zoneID, policeStationID, areaID }],
        queryFn: fetchArea,
        // staleTime: 5 * 60 * 1000,
        retry: 1,
    });
export const useShopData = (cityID, zoneID, policeStationID, areaID) =>
    useQuery({
        queryKey: ["use-shop-data", { cityID, zoneID, policeStationID, areaID }],
        queryFn: fetchShop,
        // staleTime: 5 * 60 * 1000,
        retry: 1,
    });
export const useCityData = () =>
    useQuery({
        queryKey: ["use-city-data"],
        queryFn: fetchCity,
        // staleTime: 5 * 60 * 1000,
        retry: 1,
    });
export const useZoneData = (cityID, zoneID) =>
    useQuery({
        queryKey: ["use-zone-data", { cityID, zoneID }],
        queryFn: fetchZone,
        // staleTime: 5 * 60 * 1000,
        retry: 1,
    });
export const usePoliceStationData = (cityID, zoneID, policeStationID) =>
    useQuery({
        queryKey: ["use-police-station-data", { cityID, zoneID, policeStationID }],
        queryFn: fetchPoliceStation,
        // staleTime: 5 * 60 * 1000,
        retry: 1,
    });
    export const useUserData = (userID) =>
        useQuery({
            queryKey: ["use-user-data", {userID}],
            queryFn: fetchUser,
            // staleTime: 5 * 60 * 1000,
            retry: 1,
            enabled :!!userID
        });
export const useAminitiesData = () =>
    useQuery({
        queryKey: ["use-aminities-data"],
        queryFn: fetchAminities,
        // staleTime: 5 * 60 * 1000,
        retry: 1,
    });
export const useShopDetailsData = (ShopDetailID, UserID, selectedArea = '') =>
    useQuery({
        queryKey: ["use_shop_details-data", { ShopDetailID, UserID, selectedArea }],
        queryFn: fetchShopDetail,
        // staleTime: 5 * 60 * 1000,
        enabled: !!ShopDetailID,
        retry: 1,
    });
export const useUserShopDetailsData = (ShopDetailID, UserID, selectedArea = '') =>
    useQuery({
        queryKey: ["use__shop_details-data", { ShopDetailID, UserID, selectedArea }],
        queryFn: fetchUserShopDetail,
        // staleTime: 5 * 60 * 1000,
        retry: 1,
    });
export const useGetDepartmentDashboard = (filterData) =>
    useQuery({
        queryKey: ["use_department-dashboard-data", { filterData }],
        queryFn: fetchDepartmentDashboardDetail,
        // staleTime: 5 * 60 * 1000,
        retry: 1,
    });
export const useGetDetailDashboard = (filterData, modalType) =>
    useQuery({
        queryKey: ["use_detail-dashboard-data", { filterData, displayDataType: modalType }],
        queryFn: fetchDetailDashboardDetail,
        // staleTime: 5 * 60 * 1000,
        retry: 1,
        enabled: !!modalType
    });
export const useGetVendorDashboard = (UserID) =>
    useQuery({
        queryKey: ["use_vendor_dashboard_data", { UserID }],
        queryFn: fetchVenderDashboardDetail,
        // staleTime: 5 * 60 * 1000,
        retry: 1,
    });

export const useGetShopTrackingDetails = (shopDetailID, startDate, endDate) =>
    useQuery({
        queryKey: ["use_shop_tracking_details", { shopDetailID, startDate, endDate }],
        queryFn: fetchShopTrackingDetails,
        // staleTime: 5 * 60 * 1000,
        retry: 1,
    });
export const useGetShopReportDetails = (shopDetailID, startDate, endDate) =>
    useQuery({
        queryKey: ["use_shop_report_details", { shopDetailID, startDate, endDate }],
        queryFn: fetchShopReportDetails,
        // staleTime: 5 * 60 * 1000,
        retry: 1,
    });
export const useGetViolatoinTypeDetails = () =>
    useQuery({
        queryKey: ["use_violations_type_details"],
        queryFn: fetchViolatoinTypeDetails,
        // staleTime: 5 * 60 * 1000,
        retry: 1,
    });

/* Bonika 10-02-2026 Start*/

export const useShopNotOperateDetailsPagination = (rowsPerPage, filterData) =>
    useInfiniteQuery({
        queryKey: ['shopNotOperateDetailsMain', rowsPerPage, filterData], // depends on rowsPerPage
        queryFn: async ({ pageParam = null, }) => {

            const { shopOwnerName, shopOwnerMobileNo, shopDetailID, startDate, endDate, zoneID, policeStationID, divisionID, areaID, cityID } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""

            let temptItems = {
                "ShopDetailID": shopDetailID || "",
                "CityID": cityID || "",
                "ZoneID": zoneID || "",
                "DivisionID": divisionID || "",
                "PoliceStationID": policeStationID || "",
                "AreaID": areaID || "",
                "OwnerName": shopOwnerName || "",
                "OwnerMobileNo": shopOwnerMobileNo || "",
                "StartDate": formateStartData || "",
                // "EndDate": formateEndData || "",
                "IsActive": "true",
                "IsDelete": "false",
                "PerPage": rowsPerPage,
                "UniqueID": pageParam
            }
            // if(!userRole){
            //   return 
            // }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shopTrackingDetail/getShopNotUsedByLast2Days`, temptItems, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            return res.data;
        },
        initialPageParam: null, // first page: no cursor
        getNextPageParam: (lastPage) => lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.ShopDetailID : undefined,
    });

export const useShopNotOperateExcel = () => {
    return useMutation({
        mutationFn: async (filterData) => {
            const { shopOwnerName, shopOwnerMobileNo, shopDetailID, startDate, endDate, zoneID, policeStationID, divisionID, areaID, cityID } = filterData || {}
            let formateStartData = startDate ? moment(startDate).format('DD-MM-YYYY') : ""
            let formateEndData = endDate ? moment(endDate).format('DD-MM-YYYY') : ""
            let temptItems = {
                "ShopDetailID": shopDetailID || "",
                "CityID": cityID || "",
                "ZoneID": zoneID || "",
                "DivisionID": divisionID || "",
                "PoliceStationID": policeStationID || "",
                "AreaID": areaID || "",
                "OwnerName": shopOwnerName || "",
                "OwnerMobileNo": shopOwnerMobileNo || "",
                "StartDate": formateStartData || "",
                // "EndDate": formateEndData || "",
                "IsActive": "true",
                "IsDelete": "false",
                "PerPage": "",
                "UniqueID": ""
            }

            const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shopTrackingDetail/getShopNotUsedByLast2Days`, temptItems);
            return res?.data?.data
        },
    });
};

/* Bonika 10-02-2026 End*/





const fetchShopTrackingDetails = async ({ queryKey }) => {

    const [_key, { shopDetailID, startDate, endDate }] = queryKey;
    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shopTrackingDetail/getShopTrackingDetail`,
        {
            IsActive: "true", IsDelete: "false",
            ShopDetailID: shopDetailID || "",
            StartDate: startDate || "",
            EndDate: endDate || ""
            // ShopOwnerUserID: UserID || ""
        });
    return res.data?.data || [];
}

const fetchShopReportDetails = async ({ queryKey }) => {

    const [_key, { shopDetailID, startDate, endDate }] = queryKey;
    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shopReportDetail/getShopReportDetail`,
        {
            IsActive: "true", IsDelete: "false",
            ShopDetailID: shopDetailID || "",
            StartDate: startDate || "",
            EndDate: endDate || ""
        });
    return res.data?.data || [];
}

const fetchViolatoinTypeDetails = async () => {


    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}violationsType/getViolationsType`,
        {
            IsActive: "true", IsDelete: "false",

        });
    return res.data?.data || [];
}

const fetchShopDetail = async ({ queryKey }) => {
    const [_key, { ShopDetailID, UserID, selectedArea }] = queryKey;
    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shop/getShopDetail`,
        {
            IsActive: "true", IsDelete: "false",
            ShopDetailID: ShopDetailID || "", UserID: UserID || "", AreaID: selectedArea || ""
        });
    return res.data?.data || [];
};
const fetchUserShopDetail = async ({ queryKey }) => {
    const [_key, { ShopDetailID, UserID, selectedArea }] = queryKey;
    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shop/getShopDetail`,
        {
            IsActive: "true", IsDelete: "false",
            ShopDetailID: ShopDetailID || "", UserID: UserID || "", AreaID: selectedArea || ""
        });
    return res.data?.data || [];
};
const fetchDepartmentDashboardDetail = async ({ queryKey }) => {
    const [_key, { filterData }] = queryKey;
    let formateStartData = filterData?.startDate ? moment(filterData?.startDate).format('DD-MM-YYYY') : ""
    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}dashboard/getDashboard_v2`,
        {
            // IsActive: "true", IsDelete: "false",
            "CityID": filterData.cityID || "",
            "ZoneID": filterData.zoneID || "",
            // "ZoneID": "4,1",
            "PoliceStationID": filterData.policeStationID || "",
            "AreaID": filterData.areaID || "",
            "StartDate": formateStartData
            // "StartDate": "15-01-2026"

        });
    return res.data?.data || [];
};
const fetchDetailDashboardDetail = async ({ queryKey }) => {
    const [_key, { filterData, displayDataType }] = queryKey;
    let formateStartData = filterData?.startDate ? moment(filterData?.startDate).format('DD-MM-YYYY') : ""
    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}dashboard/getDashboardDetailData`,
        {

            // IsActive: "true", IsDelete: "false",
            "CityID": filterData.cityID || "",
            "ZoneID": filterData.zoneID || "",
            // "ZoneID": "4,1",
            "PoliceStationID": filterData.policeStationID || "",
            "AreaID": filterData.areaID || "",
            "StartDate": formateStartData,
            "DisplayDataType": displayDataType || ""
            // "StartDate": "15-01-2026"

        });
    return res.data?.data || [];
};
const fetchVenderDashboardDetail = async ({ queryKey }) => {
    const [_key, { UserID }] = queryKey;
    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}dashboard/getVendorDashboard`,
        {
            UserID: UserID || ""
        });
    return res.data?.data || [];
};
const fetchTypeMaster = async ({ queryKey }) => {
    const [_key, { category }] = queryKey;
    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}typeMaster/getTypeMaster`,
        { IsActive: "true", IsDelete: "false", Category: category });
    return res.data?.data || [];
};

const fetchShopOwnRentorSubtenantCount = async ({ queryKey }) => {
    const [_key, { countFilterData }] = queryKey;
    const { zoneID, policeStationID, areaID, cityID } = countFilterData || {}
    let temptItems = {
        "CityID": cityID || "",
        "ZoneID": zoneID || "",
        "PoliceStationID": policeStationID || "",
        "AreaID": areaID || "",
        "IsActive": "",
        "IsDelete": "false"
    }
    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shop/getShopOwnRentorSubtenantCount`,
        temptItems);
    return res.data?.data || [];
};

const fetchArea = async ({ queryKey }) => {
    const [_key, { cityID, zoneID, policeStationID, areaID }] = queryKey;
    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}area/getArea`,
        {
            IsActive: "true", IsDelete: "false",
            "CityID": cityID || "",
            "ZoneID": zoneID || "",
            "PoliceStationID": policeStationID || "",
            "AreaID": areaID || ""
        });
    return res.data?.data || [];
};
const fetchShop = async ({ queryKey }) => {
    const [_key, { cityID, zoneID, policeStationID, areaID }] = queryKey;
    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}shop/getShopDetailForDropdown`,
        {
            IsActive: "true", IsDelete: "false",
            "CityID": cityID || "",
            "ZoneID": zoneID || "",
            "PoliceStationID": policeStationID || "",
            "AreaID": areaID || ""
        });
    return res.data?.data || [];
};
const fetchCity = async () => {

    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}city/getCity`,
        { IsActive: "true", IsDelete: "false" });
    return res.data?.data || [];
};
const fetchZone = async ({ queryKey }) => {
    const [_key, { cityID, zoneID }] = queryKey;
    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}zone/getZone`,
        { IsActive: "true", IsDelete: "false", CityID: cityID || "", ZoneID: zoneID || "" });
    return res.data?.data || [];
};
const fetchPoliceStation = async ({ queryKey }) => {
    const [_key, { cityID, zoneID, policeStationID }] = queryKey;
    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}policeStation/getPoliceStation`,
        {
            IsActive: "true", IsDelete: "false",
            "CityID": cityID || "",
            "ZoneID": zoneID || "",
            "PoliceStationID": policeStationID || "",
        });
    return res.data?.data || [];
};
const fetchUser = async ({ queryKey }) => {
    const [_key, { userID }] = queryKey;
    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}user/getUser`,
        {
            IsActive: "true", IsDelete: "false",
            "UserID": userID || "",

        });
    return res.data?.data || [];
};
const fetchAminities = async () => {
    const res = await axiosInstance.post(`${NIGHT_EYE_API_URL}amenities/getAmenities`,
        { IsActive: "true", IsDelete: "false" });
    return res.data?.data || [];
};